import { AppearanceConfig } from "@is/types/settings";

export const getConfigurationStyles = (appearance: AppearanceConfig) => {
  if (!appearance?.colors) {
    return {};
  }

  const stylesObject = {};

  const { colors } = appearance;

  if (colors.primary) {
    stylesObject["--theme-primary-color"] = colors.primary;
    stylesObject["--theme-select-highlighted-option-color"] = colors.primary;
  }

  if (colors.secondary) {
    stylesObject["--theme-secondary-color"] = colors.secondary;
  }

  if (colors.tertiary) {
    stylesObject["--theme-tertiary-color"] = colors.tertiary;
  }

  if (colors.sale) {
    stylesObject["--theme-sale-color"] = colors.sale;
  }

  return stylesObject;
};
